module.exports = __webpack_public_path__ + "img/CN_旺旺.efc0c408.jpg";